
      const customCSSPropertiesMap = {
        "maxContentWidth": "--awsui-max-content-width-b75yp7",
"minContentWidth": "--awsui-min-content-width-b75yp7",
"breadcrumbsGap": "--awsui-breadcrumbs-gap-b75yp7",
"contentGapLeft": "--awsui-content-gap-left-b75yp7",
"contentGapRight": "--awsui-content-gap-right-b75yp7",
"contentHeight": "--awsui-content-height-b75yp7",
"contentLayoutDefaultHorizontalPadding": "--awsui-content-layout-default-horizontal-padding-b75yp7",
"contentLayoutMaxContentWidth": "--awsui-content-layout-max-content-width-b75yp7",
"contentLayoutMainGap": "--awsui-content-layout-main-gap-b75yp7",
"defaultMaxContentWidth": "--awsui-default-max-content-width-b75yp7",
"defaultMinContentWidth": "--awsui-default-min-content-width-b75yp7",
"drawerSize": "--awsui-drawer-size-b75yp7",
"drawerMinSize": "--awsui-drawer-min-size-b75yp7",
"bottomDrawerSize": "--awsui-bottom-drawer-size-b75yp7",
"footerHeight": "--awsui-footer-height-b75yp7",
"headerGap": "--awsui-header-gap-b75yp7",
"headerHeight": "--awsui-header-height-b75yp7",
"layoutWidth": "--awsui-layout-width-b75yp7",
"mainGap": "--awsui-main-gap-b75yp7",
"mainOffsetLeft": "--awsui-main-offset-left-b75yp7",
"mainTemplateRows": "--awsui-main-template-rows-b75yp7",
"mobileBarHeight": "--awsui-mobile-bar-height-b75yp7",
"notificationsHeight": "--awsui-notifications-height-b75yp7",
"offsetTop": "--awsui-offset-top-b75yp7",
"overlapHeight": "--awsui-overlap-height-b75yp7",
"navigationWidth": "--awsui-navigation-width-b75yp7",
"splitPanelReportedHeaderSize": "--awsui-split-panel-reported-header-size-b75yp7",
"splitPanelReportedSize": "--awsui-split-panel-reported-size-b75yp7",
"splitPanelHeight": "--awsui-split-panel-height-b75yp7",
"splitPanelMinWidth": "--awsui-split-panel-min-width-b75yp7",
"splitPanelMaxWidth": "--awsui-split-panel-max-width-b75yp7",
"toolsMaxWidth": "--awsui-tools-max-width-b75yp7",
"toolsWidth": "--awsui-tools-width-b75yp7",
"toolsAnimationStartingOpacity": "--awsui-tools-animation-starting-opacity-b75yp7",
"contentScrollMargin": "--awsui-content-scroll-margin-b75yp7",
"flashbarStackDepth": "--awsui-flashbar-stack-depth-b75yp7",
"flashbarStackIndex": "--awsui-flashbar-stack-index-b75yp7",
"flashbarStickyBottomMargin": "--awsui-flashbar-sticky-bottom-margin-b75yp7",
"stackedNotificationsBottomMargin": "--awsui-stacked-notifications-bottom-margin-b75yp7",
"stackedNotificationsDefaultBottomMargin": "--awsui-stacked-notifications-default-bottom-margin-b75yp7",
"dropdownDefaultMaxWidth": "--awsui-dropdown-default-max-width-b75yp7",
"spinnerRotatorFrom": "--awsui-spinner-rotator-from-b75yp7",
"spinnerRotatorTo": "--awsui-spinner-rotator-to-b75yp7",
"spinnerLineLeftFrom": "--awsui-spinner-line-left-from-b75yp7",
"spinnerLineLeftTo": "--awsui-spinner-line-left-to-b75yp7",
"spinnerLineRightFrom": "--awsui-spinner-line-right-from-b75yp7",
"spinnerLineRightTo": "--awsui-spinner-line-right-to-b75yp7",
"sliderLabelCount": "--awsui-slider-label-count-b75yp7",
"sliderTickCount": "--awsui-slider-tick-count-b75yp7",
"sliderReferenceColumn": "--awsui-slider-reference-column-b75yp7",
"sliderNextReferenceColumn": "--awsui-slider-next-reference-column-b75yp7",
"sliderMaxStart": "--awsui-slider-max-start-b75yp7",
"sliderMinEnd": "--awsui-slider-min-end-b75yp7",
"sliderRangeInlineSize": "--awsui-slider-range-inline-size-b75yp7",
"sliderTooltipPosition": "--awsui-slider-tooltip-position-b75yp7",
"togglesLeftWidth": "--awsui-toggles-left-width-b75yp7",
"togglesRightWidth": "--awsui-toggles-right-width-b75yp7",
"promptInputMaxRows": "--awsui-prompt-input-max-rows-b75yp7",
"promptInputScrollHeight": "--awsui-prompt-input-scroll-height-b75yp7",
"dragHandleAnimationInlineOffset": "--awsui-drag-handle-animation-inline-offset-b75yp7",
"dragHandleAnimationBlockOffset": "--awsui-drag-handle-animation-block-offset-b75yp7",
"styleBackgroundActive": "--awsui-style-background-active-b75yp7",
"styleBackgroundDefault": "--awsui-style-background-default-b75yp7",
"styleBackgroundDisabled": "--awsui-style-background-disabled-b75yp7",
"styleBackgroundHover": "--awsui-style-background-hover-b75yp7",
"styleBorderColorActive": "--awsui-style-border-color-active-b75yp7",
"styleBorderColorDefault": "--awsui-style-border-color-default-b75yp7",
"styleBorderColorDisabled": "--awsui-style-border-color-disabled-b75yp7",
"styleBorderColorHover": "--awsui-style-border-color-hover-b75yp7",
"styleColorActive": "--awsui-style-color-active-b75yp7",
"styleColorDefault": "--awsui-style-color-default-b75yp7",
"styleColorDisabled": "--awsui-style-color-disabled-b75yp7",
"styleColorHover": "--awsui-style-color-hover-b75yp7",
"styleFocusRingBorderColor": "--awsui-style-focus-ring-border-color-b75yp7",
"styleFocusRingBorderRadius": "--awsui-style-focus-ring-border-radius-b75yp7",
"styleFocusRingBorderWidth": "--awsui-style-focus-ring-border-width-b75yp7",
"styleFocusRingBoxShadow": "--awsui-style-focus-ring-box-shadow-b75yp7",
"styleBoxShadowActive": "--awsui-style-box-shadow-active-b75yp7",
"styleBoxShadowDefault": "--awsui-style-box-shadow-default-b75yp7",
"styleBoxShadowDisabled": "--awsui-style-box-shadow-disabled-b75yp7",
"styleBoxShadowHover": "--awsui-style-box-shadow-hover-b75yp7",
"styleBackgroundReadonly": "--awsui-style-background-readonly-b75yp7",
"styleBorderColorReadonly": "--awsui-style-border-color-readonly-b75yp7",
"styleBoxShadowReadonly": "--awsui-style-box-shadow-readonly-b75yp7",
"styleColorReadonly": "--awsui-style-color-readonly-b75yp7",
"styleBackgroundFocus": "--awsui-style-background-focus-b75yp7",
"styleBorderColorFocus": "--awsui-style-border-color-focus-b75yp7",
"styleBoxShadowFocus": "--awsui-style-box-shadow-focus-b75yp7",
"styleColorFocus": "--awsui-style-color-focus-b75yp7",
"stylePlaceholderColor": "--awsui-style-placeholder-color-b75yp7",
"stylePlaceholderFontSize": "--awsui-style-placeholder-font-size-b75yp7",
"stylePlaceholderFontStyle": "--awsui-style-placeholder-font-style-b75yp7",
"stylePlaceholderFontWeight": "--awsui-style-placeholder-font-weight-b75yp7",
"alertFocusRingBorderColor": "--awsui-alert-focus-ring-border-color-b75yp7",
"alertFocusRingBorderRadius": "--awsui-alert-focus-ring-border-radius-b75yp7",
"alertFocusRingBorderWidth": "--awsui-alert-focus-ring-border-width-b75yp7",
"alertFocusRingBoxShadow": "--awsui-alert-focus-ring-box-shadow-b75yp7",
"alertIconColor": "--awsui-alert-icon-color-b75yp7",
      };
      export default customCSSPropertiesMap;
    